import { render, staticRenderFns } from "./StockOrderItemStatusSelect.vue?vue&type=template&id=5d610d74"
import script from "./StockOrderItemStatusSelect.vue?vue&type=script&lang=ts"
export * from "./StockOrderItemStatusSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports